export const DATE_FNS_PATTERN_ISO_DAY = 'yyyy-MM-dd'

export const DATE_FNS_PATTERN_ISO_MONTH = 'yyyy-MM'

export const DATE_FNS_PATTERN_DATE = 'dd.MM.yyyy'

export const DATE_FNS_PATTERN_TIME_HM = 'HH:mm'

export const DATE_FNS_PATTERN_YEAR = 'yyyy'

export const DATE_FNS_PATTERN_DAY_OF_MONTH = 'd'

export const DATE_FNS_PATTERN_MONTH_LONG = 'LLLL'

export const DATE_FNS_PATTERN_DAY_MONTH = 'd MMMM'

export const DATE_FNS_PATTERN_WEEKDAY_LONG = 'EEEE'

export const DATE_LOCAL_NOON_SUFFIX = 'T12:00:00'
